import util from '@bmp-vue/core/api/util'
import Axios from 'axios'

const controller = 'Webhook'
const getToken = () => JSON.parse(localStorage.getItem('user'))?.token;
const url = process.env.VUE_APP_ROOT_API + controller
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  Post: function (acao, dto) {
    var request = { acao: acao, Dto: dto }
    var header = { headers: { acao: acao } }

    return util.Axios.Post(controller, request, header)
  },
  PostSemLoading: function (acao, dto) {
    const request = { acao: acao, Dto: dto }
    const headers = { acao: acao, Authorization: `Bearer ${getToken()}` }
    return Axios.post(url, request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  ConsultarDataCrawler: function (requestId) {
    const headers = { Authorization: `Bearer ${getToken()}` }
    return Axios.get(url + '/ConsultarDataCrawler/' + requestId, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  ClearTimerIntervals: function () {
    const intervalId = window.setInterval(function () {}, Number.MAX_SAFE_INTEGER);

    for (let i = 1; i < intervalId; i++) {
      window.clearInterval(i);
    }
  }
})
